import { render } from "./QrProfile.vue?vue&type=template&id=4d952216&scoped=true"
import script from "./QrProfile.vue?vue&type=script&lang=js"
export * from "./QrProfile.vue?vue&type=script&lang=js"

import "./QrProfile.vue?vue&type=style&index=0&id=4d952216&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d952216"]])

export default __exports__